/* STORE DETAILS */
export const STORE_DETAILS_FETCH_REQUEST = "STORE_DETAILS_FETCH_REQUEST";
export const STORE_DETAILS_FETCH_SUCCESS = "STORE_DETAILS_FETCH_SUCCESS";
export const STORE_DETAILS_FETCH_FAILURE = "STORE_DETAILS_FETCH_FAILURE";

export const UPDATE_FOLLOW_STATUS = 'UPDATE_FOLLOW_STATUS';


